import { createPersist } from 'api/helper'
import { callCloudFunction } from 'utils/cloudbase'
import { PlatformModel } from './types'

/**
 * 获取所有相关平台信息
 * @description 用户本地缓存24小时
 */
export const getPlatforms = createPersist(async (): Promise<PlatformModel[]> => {
    const resp = await callCloudFunction({
        action: 'getPlatforms'
    }) as PlatformModel[]

    return resp || []
}, 'platforms', 24 * 60 * 60)